import api from "@/api";

/**
 * Vérifie le statut d'abonnement du vétérinaire
 * @returns {Promise} Réponse de l'API avec les informations d'abonnement
 */
export const checkSubscriptionStatus = async () => {
  const response = await api.get("/subscription-status");
  return response.data;
};

/**
 * Récupère la liste des produits croquettes avec leurs variants et configurations
 * @returns {Promise} Liste des produits avec variants et prix configurés
 */
export const getCroquettesProducts = async () => {
  try {
    const response = await api.get("/croquettes-products");
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des produits croquettes:", error);
    throw error;
  }
};

/**
 * Met à jour les configurations de prix pour plusieurs variants
 * @param {Array} configurations - Liste des configurations à mettre à jour
 * @param {number} configurations[].variantId - ID du variant
 * @param {string} configurations[].configuredPriceTtc - Prix TTC configuré
 * @returns {Promise} Réponse de l'API avec les configurations mises à jour
 */
export const updateRationConfigurations = async configurations => {
  try {
    const response = await api.post("/ration-configurations", {
      configurations,
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour des configurations:", error);
    throw error;
  }
};
